import { render } from "./ProductInput.vue?vue&type=template&id=731977ee"
import script from "./ProductInput.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductInput.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/html/lasource-2023/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/cartes-cadeaux/components/ProductInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "731977ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('731977ee', __exports__)) {
    console.log('reload')
    api.reload('731977ee', __exports__)
  }
  
  module.hot.accept("./ProductInput.vue?vue&type=template&id=731977ee", () => {
    console.log('re-render')
    api.rerender('731977ee', render)
  })

}


export default __exports__